import { handleWithErrorMessage, addGlobalMessage } from "@/services/utils";
import api from "@/services/modules/custom-agency-pay-rates";
import {
  SET_GROUPED_CUSTOM_AGENCY_FEES,
  SET_AGGREGATED_CUSTOM_AGENCY_FEES,
  SET_IS_FETCHING_AGGREGATED_CUSTOM_AGENCY_FEES,
  SET_IS_FETCHING_GROUPED_CUSTOM_AGENCY_FEES
} from "@/store/modules/custom-agency-pay-rates/mutations";
import { SET_IS_EDITING_BOOKING_PAYRATES } from "@/store/modules/bookings/mutations";

export const FETCH_GROUPED_AGENCY_FEES = "FETCH_GROUPED_AGENCY_FEES";
export const FETCH_AGGREGATED_CUSTOM_AGENCY_FEES =
  "FETCH_AGGREGATED_CUSTOM_AGENCY_FEES";
export const BATCH_UPDATE_RATES = "BATCH_UPDATE_RATES";

export default {
  async [FETCH_GROUPED_AGENCY_FEES]({ dispatch, commit }, data) {
    const grouped = await handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getGroupedCustomerAgencyFee(data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_GROUPED_CUSTOM_AGENCY_FEES, isLoading)
    });

    commit(
      SET_GROUPED_CUSTOM_AGENCY_FEES,
      grouped.map(fee => ({
        ...fee,
        total_cost: Number(fee.total_cost).toFixed(2),
        applicants: fee.applicants.map(applicant => ({
          ...applicant,
          total_cost: Number(applicant.total_cost).toFixed(2)
        }))
      }))
    );
  },
  async [FETCH_AGGREGATED_CUSTOM_AGENCY_FEES]({ dispatch, commit }, data) {
    const fees = await handleWithErrorMessage({
      dispatch,
      request: () => api({ commit }).getCustomAgencyFees(data),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_AGGREGATED_CUSTOM_AGENCY_FEES, isLoading)
    });

    if (fees.length) {
      commit(
        SET_AGGREGATED_CUSTOM_AGENCY_FEES,
        fees.map(fee => ({
          agencyId: fee.agencyId + "",
          applicationId: fee.applicationId + "",
          preAwr: Number(fee.preAwr).toFixed(2),
          postAwr: Number(fee.postAwr).toFixed(2)
        }))
      );
    } else {
      commit(SET_AGGREGATED_CUSTOM_AGENCY_FEES, [
        {
          agencyId: null,
          applicationId: null,
          preAwr: null,
          postAwr: null
        }
      ]);
    }
  },
  async [BATCH_UPDATE_RATES](
    { dispatch, commit },
    { bookingId, customAgencyRates }
  ) {
    await handleWithErrorMessage({
      request: () =>
        api({ commit }).editCustomAgencyFee({
          bookingId,
          customAgencyRates: customAgencyRates.map(fee => ({
            agencyId: fee.agencyId === "null" ? null : fee.agencyId,
            applicationId:
              fee.applicationId === "null" ? null : fee.applicationId,
            preAwr: fee.preAwr,
            postAwr: fee.postAwr
          }))
        }),
      dispatch,
      setLoadingFunction: isLoading =>
        commit("bookings/" + SET_IS_EDITING_BOOKING_PAYRATES, isLoading, {
          root: true
        })
    });

    addGlobalMessage(dispatch, { type: "success" });
    dispatch(FETCH_GROUPED_AGENCY_FEES, { bookingId });
    return true;
  }
};
